module.exports = __webpack_public_path__ + "img/1723083738452-lumpur surga.jpg.ca26c9dd.webp";